import * as React from "react"
import { useNavigate, useParams } from "react-router-dom"
import { registerAttendance } from "../auth/api"

export default function AttendanceCheckIn({ user }) {
  const navigate = useNavigate()
  const { token } = useParams()
  const [status, setStatus] = React.useState("loading")
  // status: "loading" | "success" | "duplicate" | "error" | "not-student"
  const [message, setMessage] = React.useState("")

  React.useEffect(() => {
    if (user?.role !== "student") {
      setStatus("not-student")
      return
    }

    let mounted = true
    async function checkIn() {
      try {
        const res = await registerAttendance(token)
        if (!mounted) return
        if (res?.alreadyRegistered) {
          setStatus("duplicate")
        } else {
          setStatus("success")
        }
        setMessage(res?.message || "")
      } catch (err) {
        if (!mounted) return
        setStatus("error")
        setMessage(err?.message || "Não foi possível registrar a presença.")
      }
    }
    checkIn()
    return () => {
      mounted = false
    }
  }, [user, token])

  return (
    <div className="min-h-screen w-full bg-[#00072D] flex items-center justify-center font-oswald p-6">
      <div className="w-full max-w-md bg-slate-50 rounded-2xl p-6 sm:p-8 shadow-2xl text-center">
        {status === "loading" && (
          <p className="text-slate-700 font-semibold">Registrando presença...</p>
        )}

        {status === "not-student" && (
          <>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">
              Check-in disponível só para alunos
            </h2>
            <p className="text-slate-500">
              Entre com uma conta de aluno para registrar presença por aqui.
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="text-4xl mb-2">✓</div>
            <h2 className="text-2xl font-semibold text-green-600 mb-2">
              Presença confirmada
            </h2>
            <p className="text-slate-700">{message}</p>
          </>
        )}

        {status === "duplicate" && (
          <>
            <h2 className="text-2xl font-semibold text-amber-600 mb-2">
              Você já assinou hoje
            </h2>
            <p className="text-slate-700">{message}</p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="text-2xl font-semibold text-red-600 mb-2">
              Não foi possível registrar
            </h2>
            <p className="text-slate-700">{message}</p>
          </>
        )}

        {status !== "loading" && (
          <button
            onClick={() => navigate("/")}
            type="button"
            className="mt-6 px-5 py-2.5 rounded-lg bg-cor-base text-slate-100 font-semibold hover:scale-[1.03] active:scale-[.96] transition-all"
          >
            Voltar ao painel
          </button>
        )}
      </div>
    </div>
  )
}
